import labelInputMixin from "../_mixin";
export default {
  name: "commonTimePicker",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h("el-time-picker", data);
    }
  },
};
